import { ACCEPTED_FILE_IMPORT_EXT, FILE_IMPORT_MAX_SIZE } from "Constants";
import type {
  ModalDelesteFileImportState,
  TableState,
  UploaderState,
} from "Pages/ImportWizard/model";
import { UPLOADER_VARIANT_DEFAULT } from "mailup-web-components";
import { atom, selector } from "recoil";

export const uploaderState = atom<UploaderState>({
  key: "ImportFile_UploaderState",
  default: {
    variant: UPLOADER_VARIANT_DEFAULT,
    hintDanger: "",
    file: undefined,
    fileName: "",
    filePath: "",
  },
});

export const importTypeState = atom<string>({
  key: "ImportFile_importTypeState",
  default: "file",
});

export const tableState = atom<TableState>({
  key: "ImportFile_tableState",
  default: {
    loading: false,
    items: [],
    totalItems: 0,
    orderBy: "CreationTime",
    orderDescending: true,
    pageNumber: 1,
    pageSize: 10,
    fileSelected: "",
    fileSelectedExt: "",
  },
});

export const modalDelesteImpostsState = atom<ModalDelesteFileImportState>({
  key: "recipientsImportModalDelesteImpostsStateStep1",
  default: {
    show: false,
    fileName: "",
  },
});
